import React, { useEffect, useRef, useState } from "react";

import Footer from "../Components/Footer";

import IndiaBoatsTopBar from "../Components/IndiaBoatsTopBar";
import PremiumNavbar from "../Components/PremiumNavbar";



const Gallery = () => {

     const [selectedImage, setSelectedImage] = useState(null);
  const [activeCategory, setActiveCategory] = useState('All');

  // Sample gallery data with curated high-res yacht imagery
  const galleryData = [
    {
      id: 1,
      title: "Luxury Catamaran Cruise",
      category: "Yachts",
      type: "image",
      location: "Mumbai Coast",
      mediaUrl: "assets/img/pyc1.JPG",
      description: "Sailing smoothly along the Mumbai shoreline during golden hour."
    },
    {
      id: 2,
      title: "Sunset Sail Experience",
      category: "Sunset Sails",
      type: "image",
      location: "Gateway of India",
      mediaUrl: "assets/img/pyc2.JPG",
      description: "Breathtaking dusk views over Arabian Sea horizons."
    },
    {
      id: 3,
      title: "Private Birthday Celebration",
      category: "Events",
      type: "image",
      location: "Goa Waters",
      mediaUrl: "assets/img/pyc3.JPG",
      description: "Custom hosted birthday party aboard our luxury deck."
    },
    {
      id: 4,
      title: "Elephanta Island Expedition",
      category: "Destinations",
      type: "image",
      location: "Elephanta Caves Route",
      mediaUrl: "assets/img/pyc4.JPG",
      description: "Guided private island transit with scenic ocean navigation."
    },
    {
      id: 5,
      title: "Premium Motor Yacht Charter",
      category: "Yachts",
      type: "image",
      location: "Mandwa Escapes",
      mediaUrl: "assets/img/pyc5.JPG",
      description: "High-speed coastal transfers with air-conditioned luxury lounge."
    },
    {
      id: 6,
      title: "Romantic Dinner & Proposal",
      category: "Events",
      type: "image",
      location: "Mumbai Harbor",
      mediaUrl: "assets/img/pyc6.JPG",
      description: "Candlelight dining setup crafted for memorable proposals."
    },
    {
      id: 7,
      title: "Speedboat Coastal Dash",
      category: "Destinations",
      type: "image",
      location: "Mumbai to Mandwa",
      mediaUrl: "assets/img/pyc7.JPG",
      description: "Fast, comfortable sea route transit for private groups."
    },
    {
      id: 8,
      title: "Twilight Harbor Views",
      category: "Sunset Sails",
      type: "image",
      location: "Arabian Sea",
      mediaUrl: "assets/img/pyc8.JPG",
      description: "Serene evening waters ideal for relaxation and quiet escapes."
    },
    {
      id: 8,
      title: "Twilight Harbor Views",
      category: "Sunset Sails",
      type: "video",
      location: "Arabian Sea",
      mediaUrl: "assets/img/pyc8.JPG",
      description: "Serene evening waters ideal for relaxation and quiet escapes."
    },
    {
      id: 8,
      title: "Twilight Harbor Views",
      category: "Sunset Sails",
      type: "video",
      location: "Arabian Sea",
      mediaUrl: "assets/img/pyc8.JPG",
      description: "Serene evening waters ideal for relaxation and quiet escapes."
    }
  ];

  const categories = ['All', 'Yachts', 'Sunset Sails', 'Events', 'Destinations'];

  const filteredImages = activeCategory === 'All'
    ? galleryData
    : galleryData.filter(img => img.category === activeCategory);

  useEffect(() => {
    const handleKeyDown = (e) => {
      if (!selectedImage) return;
      if (e.key === 'Escape') {
        setSelectedImage(null);
      } else if (e.key === 'ArrowRight') {
        const currentIndex = filteredImages.findIndex(item => item.id === selectedImage.id);
        const nextIndex = (currentIndex + 1) % filteredImages.length;
        setSelectedImage(filteredImages[nextIndex]);
      } else if (e.key === 'ArrowLeft') {
        const currentIndex = filteredImages.findIndex(item => item.id === selectedImage.id);
        const prevIndex = (currentIndex - 1 + filteredImages.length) % filteredImages.length;
        setSelectedImage(filteredImages[prevIndex]);
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [selectedImage, filteredImages]);

   const handleNextImage = (e) => {
    e.stopPropagation();
    const currentIndex = filteredImages.findIndex(item => item.id === selectedImage.id);
    const nextIndex = (currentIndex + 1) % filteredImages.length;
    setSelectedImage(filteredImages[nextIndex]);
  };

  const handlePrevImage = (e) => {
    e.stopPropagation();
    const currentIndex = filteredImages.findIndex(item => item.id === selectedImage.id);
    const prevIndex = (currentIndex - 1 + filteredImages.length) % filteredImages.length;
    setSelectedImage(filteredImages[prevIndex]);
  };

  return (
    <>
      <IndiaBoatsTopBar />
      <PremiumNavbar />

      <div className="ib-gal-wrapper">
     
      {/* <section className="ib-gal-hero">
        <div className="ib-gal-hero-overlay"></div>
        <div className="ib-gal-hero-content">
          <span className="ib-gal-hero-subtitle">Visual Experience Showcase</span>
          <h1 className="ib-gal-hero-title">Our Fleet & Moments on the Water</h1>
          <div className="ib-gal-hero-divider"></div>
          <p className="ib-gal-hero-desc">
            Explore curated memories captured across Mumbai and Goa waters. From serene sunset charters to private celebrations on luxury yachts, step onboard through our gallery.
          </p>
        </div>
      </section> */}

      {}
      <section className="ib-gal-main">
        
        {/* Category Filters */}
        <div className="ib-gal-filters">
          {categories.map((cat) => (
            <button
              key={cat}
              className={`ib-gal-filter-btn ${activeCategory === cat ? 'active' : ''}`}
              onClick={() => setActiveCategory(cat)}
            >
              {cat}
            </button>
          ))}
        </div>

        {/* Gallery Image Cards Grid */}
        <div className="ib-gal-grid">
          {filteredImages.map((item) => (
            <div
              key={item.id}
              className="ib-gal-card"
              onClick={() => setSelectedImage(item)}
            >
              <div className="ib-gal-img-container">
               {item.type === "image" ? (
    <img
      src={item.mediaUrl}
      alt={item.title}
      className="ib-gal-img"
      loading="lazy"
    />
  ) : (
    <>
      <video
        src={item.mediaUrl}
        className="ib-gal-img"
        muted
        playsInline
        preload="metadata"
      />

      <div className="video-play-icon">
        ▶
      </div>
    </>
  )}
                <div className="ib-gal-card-overlay">
                  <div className="ib-gal-expand-badge" title="Expand View">
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
                      <polyline points="15 3 21 3 21 9"></polyline>
                      <polyline points="9 21 3 21 3 15"></polyline>
                      <line x1="21" y1="3" x2="14" y2="10"></line>
                      <line x1="3" y1="21" x2="10" y2="14"></line>
                    </svg>
                  </div>
                </div>
              </div>

              <div className="ib-gal-card-info">
                <span className="ib-gal-card-tag">{item.category}</span>
                <h3 className="ib-gal-card-title">{item.title}</h3>
                <div className="ib-gal-card-loc">
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path>
                    <circle cx="12" cy="10" r="3"></circle>
                  </svg>
                  <span>{item.location}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>

      {}
      {selectedImage && (
        <div
          className="ib-gal-modal-overlay"
          onClick={() => setSelectedImage(null)}
        >
          <div
            className="ib-gal-modal-box"
            onClick={(e) => e.stopPropagation()}
          >
            {/* Close Button */}
            <button
              className="ib-gal-modal-close"
              onClick={() => setSelectedImage(null)}
              aria-label="Close modal"
            >
              &times;
            </button>

            {/* Previous Navigation Button */}
            <button
              className="ib-gal-nav-btn ib-gal-nav-prev"
              onClick={handlePrevImage}
              aria-label="Previous image"
            >
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                <polyline points="15 18 9 12 15 6"></polyline>
              </svg>
            </button>

            {/* Next Navigation Button */}
            <button
              className="ib-gal-nav-btn ib-gal-nav-next"
              onClick={handleNextImage}
              aria-label="Next image"
            >
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                <polyline points="9 18 15 12 9 6"></polyline>
              </svg>
            </button>

            {/* Expanded Image View */}
            <div className="ib-gal-modal-img-wrap">
              {selectedImage.type === "image" ? (
    <img
      src={selectedImage.mediaUrl}
      alt={selectedImage.title}
      className="ib-gal-modal-img"
    />
  ) : (
    <video
      src={selectedImage.mediaUrl}
      className="ib-gal-modal-img"
      controls
      autoPlay
      playsInline
    />
  )}
            </div>

           
          </div>
        </div>
      )}
    </div>

      <Footer />
    </>
  );
};

export default Gallery;
